import { CheckboxField, SelectField, TextField, useFormContext } from '@calendly/form';
import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { TitleText } from '@calendly/ui/components/typography';
import { useEventType } from 'features/event_type_provider';
import { isAnyLocksEnabled } from 'services/event_type_locking';
const sectionCss = "su3uvq";
const headerCss = "h1grtkfn";
const recommendedSuffixCss = "ro3k1sg";
const cancellationPolicyTextareaCss = "c1ocmuyc";
const replyToOptions = () => [{
  value: 'hosts',
  name: I18n.t('publisher.event_type_editor.sections.communications.email_reminders.from_field.host_email')
}, {
  value: 'no-reply',
  name: I18n.t('publisher.event_type_editor.sections.communications.email_reminders.from_field.no_reply')
}];
const CancellationPolicySetting = () => {
  const {
    values
  } = useFormContext();
  return <>
      <CheckboxField name="cancellationPolicyEnabled" label={I18n.t('publisher.event_type_editor.sections.more_options.notifications.cancellation_policy_label')} description={I18n.t('publisher.event_type_editor.sections.more_options.notifications.cancellation_policy_description')} />
      {values.cancellationPolicyEnabled && <TextField name="cancellationPolicy" className={cancellationPolicyTextareaCss} type="textarea" placeholder={I18n.t('publisher.event_type_editor.sections.more_options.notifications.cancellation_policy_placeholder')} />}
    </>;
};

// "Additional settings" block for the redesigned CRUD notifications tab. These
// controls (reply-to address, cancellation policy, include cancel/reschedule
// links) are wired directly to the shared root form state — reusing the exact
// field names and semantics from the legacy notification drawers — so edits are
// persisted by the parent CRUD save rather than an implicit PATCH.
export const AdditionalSettings = () => {
  const eventType = useEventType();
  const etLocked = !eventType.isMETParent && isAnyLocksEnabled(eventType, ['v3_notifications']);
  if (etLocked) return null;
  return <div className={sectionCss} data-testid="crud-additional-settings">
      <div className={headerCss}>
        <TitleText level={3} size="medium" as="h3">
          {I18n.t('publisher.event_type_editor.sections.more_options.notifications.additional_settings')}
        </TitleText>
      </div>

      <CheckboxField name="cancellationAllowed" label={<>
            {I18n.t('publisher.event_type_editor.sections.more_options.notifications.include_links_label')}
            {' '}
            <span className={recommendedSuffixCss}>
              (
              {I18n.t('publisher.event_type_editor.sections.more_options.notifications.include_links_recommended')}
              )
            </span>
          </>} description={I18n.t('publisher.event_type_editor.sections.more_options.notifications.include_links_description')} />

      <CancellationPolicySetting />

      <SelectField name="noReply" label={I18n.t('publisher.event_type_editor.sections.communications.reply_to')} proTip={HtmlParser(I18n.t('publisher.event_type_editor.sections.communications.email_reminders.from_field.pro_tip'))} options={replyToOptions()} />
    </div>;
};

require("./additional_settings.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./additional_settings.js");